

export const CITIES = [
  { value: 'London', label: 'London' },
  { value: 'New York', label: 'New York' },
  { value: 'Tokyo', label: 'Tokyo' },
  { value: 'Paris', label: 'Paris' },
  { value: 'Mumbai', label: 'Mumbai' },
  { value: 'Sydney', label: 'Sydney' },
  { value: 'Berlin', label: 'Berlin' },
  { value: 'Singapore', label: 'Singapore' }
]

export const AQI_LEVELS = {
  GOOD: 'Good',
  MODERATE: 'Moderate',
  UNHEALTHY_SENSITIVE: 'Unhealthy for Sensitive',
  UNHEALTHY: 'Unhealthy',
  VERY_UNHEALTHY: 'Very Unhealthy',
  HAZARDOUS: 'Hazardous'
}